import React from "react";
import {UserAvatar} from "./UserAvatar";
import {useFirebaseState} from "../firebase/firebaseContext";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router";

export const UserButton = () => {
    const {auth} = useFirebaseState();
    const navigate = useNavigate();

    if (auth && auth.currentUser) {
        return <UserAvatar user={auth.currentUser} />;
    } else {
        return (
            <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate("/login")}
                sx={{
                    borderRadius: 3,
                    textTransform: "none",
                    fontWeight: 600,
                    minHeight: 44,
                    minWidth: 44,
                    px: {xs: 1.5, sm: 2},
                    py: 0.75,
                    fontSize: {xs: "0.85rem", sm: "0.875rem"},
                    flexShrink: 0,
                    whiteSpace: "nowrap",
                    "&:focus-visible": {
                        outline: "2px solid #285238",
                        outlineOffset: 2,
                    },
                }}
            >
                Logg på
            </Button>
        );
    }
};